<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="component-chat-log" class="m-8" >
       
        <div v-for="(msg, index) in message" class="msg-grp-container" :key="index">
           
            <!--<div v-if=" message" class="msg-grp-container" :key="index">-->
            <!-- If previous msg is older than current time -->
            <template v-if="message[index-1]">
                <vs-divider v-if="!isSameDay(msg.msg.time, message[index-1].msg.time)" class="msg-time">
                    <span>{{ toDate(msg.msg.time) }}</span>
                </vs-divider>
                <div class="spacer mt-8" v-if="!hasSentPreviousMsg(message[index-1].msg.isSent, msg.msg.isSent)"></div>
            </template>
            
            <div class="flex items-start" :class="[{'flex-row-reverse' : msg.msg.isSent}]">

                <template v-if="message[index-1]">
                    <template v-if="(!hasSentPreviousMsg(message[index-1].msg.isSent, msg.msg.isSent) || !isSameDay(msg.msg.time, message[index-1].msg.time))">
                        <!--<span class="text-white"> truuuuueee </span>-->
                        <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="senderImg(msg.msg.isSent)"></vs-avatar>
                    </template>
                </template>

                <template v-if="index == 0">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="senderImg(msg.msg.isSent)"></vs-avatar>
                </template>

                <template v-if="message[index-1]">
                    <div class="mr-16" v-if="!(!hasSentPreviousMsg(message[index-1].msg.isSent, msg.msg.isSent) || !isSameDay(msg.msg.time, message[index-1].msg.time))"></div>
                </template>
                <div class="mb-2">
                <div class="msg break-words relative shadow-md rounded py-3 px-4  rounded-lg max-w-sm" :class="{'bg-primary-gradient text-white': msg.msg.isSent, 'border border-solid border-grey-light bg-white': !msg.msg.isSent}">
                    <span v-if="msg.msg.textContent !==''">{{ msg.msg.textContent}}</span>
                    <span v-else  ><a target="_blank" class=" font-semibold cursor-pointer" :href='msg.msg.attachment'><U><feather-icon  icon="LinkIcon" svgClasses="w-4 h-4 mr-1"/>View Attachment</U></a></span>
                    
                </div>
                <small  class=" text-primary font-semibold " :class="[{'right' : msg.msg.isSent}]">{{ toTime(msg.msg.time) }}</small>
                </div>
            </div>
        </div>
            <template v-if="video">
            <vs-divider color="dark" class="w-full text-center msg-time text-dark font-semibold"><span class="p-3 items-center "> {{ video }} <BR/>
                 <vs-button  color="success" class="mb-2" type="gradient"    @click='videopush(userId.uid)' size="small"  >Join Now</vs-button></span></vs-divider>
            </template>
              <template v-if="schedule">
            <vs-divider color="dark" class="w-full text-center msg-time text-dark font-semibold"><span class="p-3 items-center "> {{ schedule }} <BR/>
            <span class = "center" v-if="Accepted=== true">Accepted</span>
                 <vs-button  v-if="$acl.get[0]==='editor'"  color="success" class="mb-2" type="gradient"   @click='cal(calendar)' size="small"  >{{button}}</vs-button></span></vs-divider>
            </template>
    </div>
</template>

<script>
    var saveAs=saveAs||function(e){"use strict";if(typeof e==="undefined"||typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var t=e.document,n=function(){return e.URL||e.webkitURL||e},r=t.createElementNS("http://www.w3.org/1999/xhtml","a"),o="download"in r,a=function(e){var t=new MouseEvent("click");e.dispatchEvent(t)},i=/constructor/i.test(e.HTMLElement)||e.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),u=function(t){(e.setImmediate||e.setTimeout)(function(){throw t},0)},s="application/octet-stream",d=1e3*40,c=function(e){var t=function(){if(typeof e==="string"){n().revokeObjectURL(e)}else{e.remove()}};setTimeout(t,d)},l=function(e,t,n){t=[].concat(t);var r=t.length;while(r--){var o=e["on"+t[r]];if(typeof o==="function"){try{o.call(e,n||e)}catch(a){u(a)}}}},p=function(e){if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)){return new Blob([String.fromCharCode(65279),e],{type:e.type})}return e},v=function(t,u,d){if(!d){t=p(t)}var v=this,w=t.type,m=w===s,y,h=function(){l(v,"writestart progress write writeend".split(" "))},S=function(){if((f||m&&i)&&e.FileReader){var r=new FileReader;r.onloadend=function(){var t=f?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");var n=e.open(t,"_blank");if(!n)e.location.href=t;t=undefined;v.readyState=v.DONE;h()};r.readAsDataURL(t);v.readyState=v.INIT;return}if(!y){y=n().createObjectURL(t)}if(m){e.location.href=y}else{var o=e.open(y,"_blank");if(!o){e.location.href=y}}v.readyState=v.DONE;h();c(y)};v.readyState=v.INIT;if(o){y=n().createObjectURL(t);setTimeout(function(){r.href=y;r.download=u;a(r);h();c(y);v.readyState=v.DONE});return}S()},w=v.prototype,m=function(e,t,n){return new v(e,t||e.name||"download",n)};if(typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob){return function(e,t,n){t=t||e.name||"download";if(!n){e=p(e)}return navigator.msSaveOrOpenBlob(e,t)}}w.abort=function(){};w.readyState=w.INIT=0;w.WRITING=1;w.DONE=2;w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null;return m}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!==null){define("FileSaver.js",function(){return saveAs})}

    var ics=function(e,t){"use strict";{if(!(navigator.userAgent.indexOf("MSIE")>-1&&-1==navigator.userAgent.indexOf("MSIE 10"))){void 0===e&&(e="default"),void 0===t&&(t="Calendar");var r=-1!==navigator.appVersion.indexOf("Win")?"\r\n":"\n",n=[],i=["BEoleGIN:VCALENDAR","PRODID:"+t,"VERSION:2.0"].join(r),o=r+"END:VCALENDAR",a=["SU","MO","TU","WE","TH","FR","SA"];return{events:function(){return n},calendar:function(){return i+r+n.join(r)+o},addEvent:function(t,i,o,l,u,s){if(void 0===t||void 0===i||void 0===o||void 0===l||void 0===u)return!1;if(s&&!s.rrule){if("YEARLY"!==s.freq&&"MONTHLY"!==s.freq&&"WEEKLY"!==s.freq&&"DAILY"!==s.freq)throw"Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";if(s.until&&isNaN(Date.parse(s.until)))throw"Recurrence rrule 'until' must be a valid date string";if(s.interval&&isNaN(parseInt(s.interval)))throw"Recurrence rrule 'interval' must be an integer";if(s.count&&isNaN(parseInt(s.count)))throw"Recurrence rrule 'count' must be an integer";if(void 0!==s.byday){if("[object Array]"!==Object.prototype.toString.call(s.byday))throw"Recurrence rrule 'byday' must be an array";if(s.byday.length>7)throw"Recurrence rrule 'byday' array must not be longer than the 7 days in a week";s.byday=s.byday.filter(function(e,t){return s.byday.indexOf(e)==t});for(var c in s.byday)if(a.indexOf(s.byday[c])<0)throw"Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'"}}var g=new Date(l),d=new Date(u),f=new Date,S=("0000"+g.getFullYear().toString()).slice(-4),E=("00"+(g.getMonth()+1).toString()).slice(-2),v=("00"+g.getDate().toString()).slice(-2),y=("00"+g.getHours().toString()).slice(-2),A=("00"+g.getMinutes().toString()).slice(-2),T=("00"+g.getSeconds().toString()).slice(-2),b=("0000"+d.getFullYear().toString()).slice(-4),D=("00"+(d.getMonth()+1).toString()).slice(-2),N=("00"+d.getDate().toString()).slice(-2),h=("00"+d.getHours().toString()).slice(-2),I=("00"+d.getMinutes().toString()).slice(-2),R=("00"+d.getMinutes().toString()).slice(-2),M=("0000"+f.getFullYear().toString()).slice(-4),w=("00"+(f.getMonth()+1).toString()).slice(-2),L=("00"+f.getDate().toString()).slice(-2),O=("00"+f.getHours().toString()).slice(-2),p=("00"+f.getMinutes().toString()).slice(-2),Y=("00"+f.getMinutes().toString()).slice(-2),U="",V="";y+A+T+h+I+R!=0&&(U="T"+y+A+T,V="T"+h+I+R);var B,C=S+E+v+U,j=b+D+N+V,m=M+w+L+("T"+O+p+Y);if(s)if(s.rrule)B=s.rrule;else{if(B="rrule:FREQ="+s.freq,s.until){var x=new Date(Date.parse(s.until)).toISOString();B+=";UNTIL="+x.substring(0,x.length-13).replace(/[-]/g,"")+"000000Z"}s.interval&&(B+=";INTERVAL="+s.interval),s.count&&(B+=";COUNT="+s.count),s.byday&&s.byday.length>0&&(B+=";BYDAY="+s.byday.join(","))}(new Date).toISOString();var H=["BEGIN:VEVENT","UID:"+n.length+"@"+e,"CLASS:PUBLIC","DESCRIPTION:"+i,"DTSTAMP;VALUE=DATE-TIME:"+m,"DTSTART;VALUE=DATE-TIME:"+C,"DTEND;VALUE=DATE-TIME:"+j,"LOCATION:"+o,"SUMMARY;LANGUAGE=en-us:"+t,"TRANSP:TRANSPARENT","END:VEVENT"];return B&&H.splice(4,0,B),H=H.join(r),n.push(H),H},download:function(e,t){if(n.length<1)return!1;t=void 0!==t?t:".ics",e=void 0!==e?e:"calendar";var a,l=i+r+n.join(r)+o;if(-1===navigator.userAgent.indexOf("MSIE 10"))a=new Blob([l]);else{var u=new BlobBuilder;u.append(l),a=u.getBlob("text/x-vCalendar;charset="+document.characterSet)}return saveAs(a,e+t),l},build:function(){return!(n.length<1)&&i+r+n.join(r)+o}}}console.log("Unsupported Browser")}};

import * as firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"
import moment from 'moment'
export default{
    props: {
        userId: {
            type: Object,
            required: true,
        },
        currentUser:{
            type:Object,
            required:true,
        },
        collegecode:{
            type:String
        }
    },
    data(){
        return{
            message :[],
            video:"",
            schedule:"",
            calendar:{},
            button:'Accept ',
            Accepted:false,

        }
    },
    watch:{
        message: function(){
            ////console.log(this.message)
            this.chatData
        },
        userId: function(){
            //console.log(this.userId)
            this.new_Data
            this.chatData
        },
        video:function(){
            //console.log(this.video)
            //this.videoss
        },
        Accepted: function( ){
            this.upd
        },
        
        deep: true
    },
    computed: {
        upd(){
            const user = firebase.auth().currentUser
             const schRef = firebase.database().ref(this.userId.uid).child(user.uid).child('Schedule');

           
            
        },
        sch(){
            this.Accepted
        },
        chatData() {
            // console.log(this.message)
          return this.message
           
        },
        new_Data(){
             const user = firebase.auth().currentUser
                        const thisIns = this 
              if(thisIns.userId){    
                  this.message=[]
                  if(thisIns.userId.uid == 'flairboat-chat-admin'){
                        var obj ={msg :{
                          textContent: 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.',
                          isSent:false,
                          time:new Date()
                      }}
                     var messageRef= firebase.database().ref('flairboat-chat-admin').child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        // console.log(data.val())
                       var obj2=data.val()
                        // console.log(obj2)
                        if(obj2.msg){
                          
                        if(obj2.msg.role===thisIns.$acl.get[0])
                         { 
                             obj2.msg.isSent=true
                         }
                         else if(obj2.msg.role==='support'){
                             obj2.msg.isSent=false
                         }
                          thisIns.message.push(obj2)
                           thisIns.chatData
                      }
                     
                     
                      })
                       thisIns.message.push(obj)
                           thisIns.chatData
                      
                    //    else{
                    //         obj.msg ={
                    //       textContent: 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.',
                    //       isSent:false,
                    //       time:new Date()
                    //   }
                      
                  }
                  else{
                    if(thisIns.$acl.get[0]==='post' || thisIns.$acl.get[0]==='hr'){
                      var obj ={}
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                         
                          thisIns.message.push(obj)
                           thisIns.chatData
                     
                     const schRef = firebase.database().ref(this.userId.uid).child(user.uid).child('Schedule');
                     schRef.orderByChild('timestamp').on('child_added',data=>{
                         obj= data.val()
                         obj.key=data.key
                        // console.log(obj)
                         this.Accepted= data.val().isAccepted

                         this.schedule= `Scheduled interview at ${obj.scd.begin}`
                        // console.log(this.schedule)
                            
                     })
                     this.upd
                      schRef.on('child_changed',data=>{

                                                     this.Accepted=data.val().isAccepted
                                                     if(this.Accepted)  
                                                      this.schedule='Accepted Invitation'     

                                                    // console.log("yes")

                     })

                         
                      })
                      }
                     else  if(thisIns.userId.role == 'tpo'){
                      const Ref = firebase.database().ref(user.uid).child(this.userId.uid);
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='admin'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                      })
                      
                      }
                      else  if(thisIns.userId.role == 'trp'){
                      const Ref = firebase.database().ref(user.uid).child(this.userId.uid);
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='trp'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                      })
                      
                      }
                      
                    }
                   else if(thisIns.$acl.get[0]==='hr'){
                      var obj ={}
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                     
                     const schRef = firebase.database().ref(this.userId.uid).child(user.uid).child('Schedule');
                     schRef.orderByChild('timestamp').on('child_added',data=>{
                         obj= data.val()
                         obj.key=data.key
                        // console.log(obj)
                         this.Accepted= data.val().isAccepted

                         this.schedule= `Scheduled interview at ${obj.scd.begin}`
                        // console.log(this.schedule)
                            
                     })
                     this.upd
                      schRef.on('child_changed',data=>{

                                                     this.Accepted=data.val().isAccepted
                                                     if(this.Accepted)  
                                                      this.schedule='Accepted Invitation'     

                                                    // console.log("yes")

                     })

                         
                      })
                      }
                     else  if(thisIns.userId.role == 'tpo'){
                      const Ref = firebase.database().ref(user.uid).child(this.userId.uid);
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='admin'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                      })
                      
                      }

                      else  if(thisIns.userId.role == 'trp'){
                      const Ref = firebase.database().ref(user.uid).child(this.userId.uid);
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='trp'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                      })
                      
                      }
                      
                    }
                  else if(thisIns.$acl.get[0]==='admin'){
                      var obj ={}
                //       if(thisIns.userId.uid == 'flairboat-chat-admin'){
                     
                //       obj.msg ={
                //           textContent: 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.',
                //           isSent:false,
                //           time:Date.now()
                //       }
                //       thisIns.message.push(obj)
                //            thisIns.chatData
                //   }
                //   else{
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='admin')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }
                      else if (thisIns.userId.role == 'recruiter'){
                      var Ref=firebase.database().ref(this.userId.uid).child(user.uid) 
                       Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='admin')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='post'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }

                  } 

                  else if(thisIns.$acl.get[0]==='trp'){
                      var obj ={}
                
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='trp')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }
                      else if (thisIns.userId.role == 'recruiter'){
                      var Ref=firebase.database().ref(this.userId.uid).child(user.uid) 
                       Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='trp')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='post'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }

                  } 
                
                
                    else if(thisIns.$acl.get[0]==='editor'){
                     
                      var obj ={}
                      const messageRef = firebase.database().ref(user.uid).child(this.userId.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                          obj=data.val()
                          console.log(obj)
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=false
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='admin'){
                             obj.msg.isSent=false
                         }
                         else if(obj.msg.role==='trp'){
                             obj.msg.isSent=false
                         }
                         
                          thisIns.message.push(obj)
                           thisIns.chatData
                           
                          // //console.log(obj)
                         
                 
                         
                      })
                      
                      
                     
                    
                    }

              }
              }
        },
        activeUserImg() {
            return this.$store.state.AppActiveUser.photoURL;
        },
        senderImg() {
            ////console.log(this.currentUser.profilephoto)
            return (isSentByActiveUser) => {
                if (isSentByActiveUser) return this.currentUser.profilephoto || this.currentUser.photo
                
                else return this.userId.profilephoto 

                //else return null
            }
        },
        hasSentPreviousMsg() {
            ////console.log(val,val2)
            return (last_sender, current_sender) => last_sender == current_sender
        },

    },
    methods: {
        
        
        isSameDay(time_to, time_from) {
            const date_time_to = new Date(Date.parse(time_to))
            const date_time_from = new Date(Date.parse(time_from));
            return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate();
        },
        toTime(time){
            var date = new Date(Date.parse(time))
            var d = new moment(date).format('h:mm a');
            ////console.log(d)
            return d
        },
        toTimess(time){
            //console.log(time)
            var date = new Date(Date.parse(time))
           // console.log(date)
            var d = new moment(date).format('h:mm a');
           // console.log(d)
            return d
        },
        toDate(time) {
          //  //console.log(time)
            const locale = "en-us";
            const date_obj = new Date(Date.parse(time));
            const monthName= date_obj.toLocaleString(locale, {
                month: 'short'
            });
            return date_obj.getDate() + ' '  + monthName;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
            });
        }
    },
    updated() {
        this.scrollToBottom();
        this.Accepted;
        this.button;
       // console.log( this.Accepted);


    },
    mounted() {
        this.scrollToBottom();
    },
    created(){
         const user = firebase.auth().currentUser
         const thisIns = this
         var role = thisIns.$acl.get[0]
              if(thisIns.userId){
                //   console.log(thisIns.userId)
                  if(thisIns.userId.uid == 'flairboat-chat-admin'){
                      thisIns.message=[]
                       var obj ={msg :{
                          textContent: 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.',
                          isSent:false,
                          time:new Date()
                      }}
                     var messageRef= firebase.database().ref('flairboat-chat-admin').child(user.uid);
                      messageRef.orderByChild('timestamp').once('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        // console.log(data.val())
                        var obj2=data.val()
                        // console.log(obj)
                        if(obj2.msg){
                        //   console.log(obj2)
                        if(obj2.msg.role === role)
                         { 
                             obj2.msg.isSent=true
                         }
                         else if(obj2.msg.role==='support'){
                             obj2.msg.isSent=false
                         }
                          thisIns.message.push(obj2)
                           thisIns.chatData
                      }
                     
                     
                      
                      })
                       thisIns.message.push(obj)
                    //   console.log(thisIns.message)
                           thisIns.chatData
                    //    var obj ={}
                    //  var messageRef= firebase.database().ref('flairboat-chat-admin').child(user.uid);
                    //   messageRef.orderByChild('timestamp').on('child_added' ,data => {
                    //     //  //console.log(data.val())obj=data.val()
                    //     obj=data.val()
                    //     console.log(obj)
                    //     if(typeof obj !== 'undefined'){
                          
                    //     if(obj.msg.role===this.$acl.get[0])
                    //      { obj.msg.isSent=true
                    //      }
                    //      else if(obj.msg.role==='admin-support-chat'){
                    //          obj.msg.isSent=false
                    //      }
                    //       thisIns.message.push(obj)
                    //        thisIns.chatData
                    //   }
                    //   else{
                    //         obj.msg ={
                    //       textContent: 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.',
                    //       isSent:false,
                    //       time:new Date()
                    //   }
                    //   thisIns.message.push(obj)
                    //        thisIns.chatData
                    //   }
                    //   })
                      
                      
                     
                    
                     
                  }
                  else{
                    if(thisIns.$acl.get[0]==='admin'){
                      var obj ={}
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='admin')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }
                      else if (thisIns.userId.role == 'recruiter'){
                      var Ref=firebase.database().ref(this.userId.uid).child(user.uid) 
                       Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='admin')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='post'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }

                      
                    }   
                    
                    else if(thisIns.$acl.get[0]==='trp'){
                      var obj ={}
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='trp')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }
                      else if (thisIns.userId.role == 'recruiter'){
                      var Ref=firebase.database().ref(this.userId.uid).child(user.uid) 
                       Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='trp')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='post'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData 
                      })
                      }

                      
                    } 
                    else if(thisIns.$acl.get[0]==='post' || thisIns.$acl.get[0]==='hr'){
                      var obj ={}
                      if(thisIns.userId.role == 'student'){
                      const messageRef = firebase.database().ref(this.userId.uid).child(user.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                     
                     const schRef = firebase.database().ref(this.userId.uid).child(user.uid).child('Schedule');
                     schRef.orderByChild('timestamp').on('child_added',data=>{
                         obj= data.val()
                         obj.key=data.key
                        // console.log(obj)
                         this.Accepted= data.val().isAccepted
                         

                         this.schedule= `Scheduled interview at ${obj.scd.begin}`
                        // console.log(this.schedule)
                            
                     })
                     this.upd
                      schRef.on('child_changed',data=>{

                                                     this.Accepted=data.val().isAccepted
                                                     if(this.Accepted)  
                                                      this.schedule='Accepted Invitation'     

                                                    // console.log("yes")

                     })

                         
                      })
                      }
                     else  if(thisIns.userId.role == 'tpo'){
                      const Ref = firebase.database().ref(user.uid).child(this.userId.uid);
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='admin'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                      })
                      
                      }

                      else  if(thisIns.userId.role == 'trp'){
                      const Ref = firebase.database().ref(user.uid).child(this.userId.uid);
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                        //  //console.log(data.val())obj=data.val()
                        obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='trp'){
                             obj.msg.isSent=false
                         }
                          thisIns.message.push(obj)
                           thisIns.chatData
                      })
                      
                      }
                      
                    }
                    else if(thisIns.$acl.get[0]==='editor'){
                     
                      var obj ={}
                      const messageRef = firebase.database().ref(user.uid).child(this.userId.uid);
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                          obj=data.val()
                          if(obj.msg.role==='post')
                         { obj.msg.isSent=false
                         }
                         else if(obj.msg.role==='editor'){
                             obj.msg.isSent=true
                         }
                         else if(obj.msg.role==='admin'){
                             obj.msg.isSent=false
                         }
                         else if(obj.msg.role==='trp'){
                             obj.msg.isSent=false
                         }
                         
                          thisIns.message.push(obj)
                           thisIns.chatData
                           
                          // //console.log(obj)
                         
                 
                         
                      })
                      
                      
                     
                    
                    }
              }  
              }  

    }
}
</script>
<style lang="scss" >
.right{
    float: right;
}
.left{
    float: left;
}
</style>